export default __webpack_public_path__ + "static/media/Clan Boud Boots of the Four Winds.ae87cf3a.jpg";